import { CategoriesResponse } from '@shopby/shop-sdk'
import { accessToken, client, userClient } from './auth'

/* 필터항목
  filter.discountedPrices - 가격간 검색 2개의 가격 전달해야함
  filter.keywords - 검색어
  filter.deliveryConditionType - 배송비타입
  order.by - POPULAR:판매인기순 (DEFAULT), SALE_YMD:판매일자, SALE_END_YMD:판매종료일자, DISCOUNTED_PRICE:가격순, REVIEW:상품평, SALE_CNT:총판매량순, RECENT_PRODUCT:최근상품순, MD_RECOMMEND:MD추천순, LIKE_CNT: 좋아요, EXPIRATION_DATE: 유효일자
  order.direction - 위의 조건 정렬기준
  categoryNos - 전시 카테고리 번호
  brandNos - 브랜드 번호
  pageNumber - 페이지 번호
  pageSize - 한 페이지당 노출 수
  */

/** 상품 검색(전체 상품목록 가져오기) */
export async function getProductSearch() {
  return await client.get(`/products/search?filter.soldout=true&filter.saleStatus=ALL_CONDITIONS`)
}

/** 상품 정렬하기 */
export async function getAlignProductSearch(orderKeyword: string, page: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

/** 상품 카테고리 넘버로 조회 핫딜에서 사용 */
export async function getCategoryNoSearch(page: number, categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&pageNumber=${page}&pageSize=10`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&pageNumber=${page}&pageSize=10`
    )
  }
}

/** 상품 카테고리 넘버로 조회 페스티벌에서 사용 */
export async function getCategoryNoSearchNumber(page: number, categoryNo: number, pageSize: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&pageNumber=${page}&pageSize=${pageSize}&order.by=POPULAR`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&pageNumber=${page}&pageSize=${pageSize}&order.by=POPULAR`
    )
  }
}

/** 상품 카테고리 넘버로 조회 */
export async function getCategorySearch(orderKeyword: string, page: number, categoryNo: number) {
  return await client.get(
    `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}&pageSize=6`
  )
}

/** 상품 카테고리 넘버로 조회 */
export async function getFestivalCategorySearch(orderKeyword: string, page: number, categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}&pageSize=12`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}&pageSize=12`
    )
  }
}

/** 상품 카테고리 카테고리 넘버로 조회 */
export async function getCategoryCartSearch(categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=1&pageSize=500&filter.totalReviewCount=true`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=1&pageSize=500&filter.totalReviewCount=true`
    )
  }
}

export async function getCategoryAllSearch(page: number, categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=${page}&pageSize=500`
    )
  } else {
    return await client.get(
      `/products/search?categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=${page}&pageSize=500`
    )
  }
}

/** 상품 카테고리 정렬 */
export async function getSortCategorySearch(orderKeyword: string, page: number, categoryNo: number, sort: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

/** 상품 카테고리 정렬 */
export async function getSortCategoryHomeSearch(orderKeyword: string, page: number, categoryNo: number, sort: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&pageSize=4&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sort}&categoryNos=${categoryNo}&pageSize=4&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

/** 많이 팔린 상품 */
export async function getPopSaleCategorySearch(orderKeyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=1&pageSize=4`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=1&pageSize=4`
    )
  }
}

/** 많이 팔린 상품 */
export async function getSaleCategorySearch(orderKeyword: string, page: number, sort: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sort}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sort}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

/** 브랜드 가져오기 */
export async function getBrands() {
  return await client.get(`/display/brands?pageSize=500&pageNumber=1`)
}

/** 상품카테고리 필터 적용 */
export async function getFilterList(
  orderKeyword: string,
  page: number,
  categoryNo: number,
  sort: string,
  brandNo: any,
  min: number,
  max: number,
  freeCheck: boolean
) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?brandNos=${brandNo}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
        freeCheck ? `FREE` : null
      }&order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?brandNos=${brandNo}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
        freeCheck ? `FREE` : null
      }&order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

export async function getUserFilterList(
  orderKeyword: string,
  page: number,
  categoryNo: number,
  sort: string,
  brandNo: any,
  min: number,
  max: number,
  freeCheck: boolean
) {
  return await userClient.get(
    `/products/search?brandNos=${brandNo}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
      freeCheck ? `FREE` : null
    }&order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
  )
}

export async function getGuestFilterList(
  orderKeyword: string,
  page: number,
  categoryNo: number,
  sort: string,
  brandNo: any,
  min: number,
  max: number,
  freeCheck: boolean
) {
  return await client.get(
    `/products/search?brandNos=${brandNo}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
      freeCheck ? `FREE` : null
    }&order.direction=${sort}&filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
  )
}

/** 상품카테고리 필터 적용 */
export async function getFilterFestivalList(categoryNo: number) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=1&pageSize=12`
    )
  } else {
    return await client.get(
      `/products/search?filter.totalReviewCount=true&categoryNos=${categoryNo}&filter.includeNonDisplayableCategory=true&order.soldoutPlaceEnd=true&filter.soldout=true&saleStatus=ALL_CONDITIONS&pageNumber=1&pageSize=12`
    )
  }
}
//
/** 상품 키워드로 검색 */
export async function getKeywordSearch(orderKeyword: string, page: number, keyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageSize=500`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageSize=500`
    )
  }
}

/** 상품 키워드로 몇카테고리 제외 검색 */
export async function getKeywordExceptSearch(orderKeyword: string, page: number, keyword: string, category: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&excludeCategoryNos=${category}&pageNumber=${page}&filter.keywords=${keyword}&pageSize=500`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&excludeCategoryNos=${category}&pageNumber=${page}&filter.keywords=${keyword}&pageSize=500`
    )
  }
}

export async function getAllKeywordSearch(orderKeyword: string, page: number, keyword: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageNumber=${page}&pageSize=500`
    )
  } else {
    return await client.get(
      `/products/search?filter.soldout=true&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&filter.keywords=${keyword}&pageNumber=${page}&pageSize=500`
    )
  }
}

/** 상품 키워드 아이템 검색 */
export async function getKeywordSearchSort(orderKeyword: string, page: number, keyword: string, sortDirection: string) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?order.direction=${sortDirection}&filter.soldout=true&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.soldoutPlaceEnd=true&order.by=${orderKeyword}&filter.keywords=${keyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?order.direction=${sortDirection}&filter.soldout=true&filter.totalReviewCount=true&saleStatus=ALL_CONDITIONS&order.soldoutPlaceEnd=true&order.by=${orderKeyword}&filter.keywords=${keyword}&pageNumber=${page}`
    )
  }
}

export async function getMall() {
  return await client.get(`/malls`)
}

/** 상품 필터 */
export async function getFilterProductSearch(bradnNO: string, include: boolean, startPrice: string, endPrice: string) {
  return await client.get(
    `/products/search?filter.soldout=true&saleStatus=ALL_CONDITIONS&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&brandNos=${bradnNO}&filter.deliveryConditionType=${
      include ? 'FIXED_FEE' : 'FREE'
    }&filter.discountedPrices=${startPrice},${endPrice}`
  )
}

/** 상품검색 필터 적용 */
export async function getSearchFilterList(
  orderKeyword: string,
  page: number,
  keyword: string,
  sort: string,
  brandNo: any,
  min: number,
  max: number,
  freeCheck: boolean
) {
  return await client.get(
    `/products/search?brandNos=${brandNo}&filter.keywords=${keyword}&filter.totalReviewCount=true&order.soldoutPlaceEnd=true&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
      freeCheck ? `FREE` : null
    }&order.direction=${sort}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
  )
}

/** 상품검색 필터 적용 */
export async function getSearchExceptFilterList(
  orderKeyword: string,
  page: number,
  keyword: string,
  sort: string,
  brandNo: any,
  min: number,
  max: number,
  freeCheck: boolean,
  categoryNo: number
) {
  if (accessToken) {
    return await userClient.get(
      `/products/search?brandNos=${brandNo}&excludeCategoryNos=${categoryNo}&filter.keywords=${keyword}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
        freeCheck ? `FREE` : null
      }&filter.totalReviewCount=true&order.direction=${sort}&order.soldoutPlaceEnd=true&excludeCategoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  } else {
    return await client.get(
      `/products/search?brandNos=${brandNo}&excludeCategoryNos=${categoryNo}&filter.keywords=${keyword}&filter.discountedPrices=${min},${max}&filter.deliveryConditionType=${
        freeCheck ? `FREE` : null
      }&filter.totalReviewCount=true&order.direction=${sort}&order.soldoutPlaceEnd=true&excludeCategoryNos=${categoryNo}&filter.soldout=true&saleStatus=ALL_CONDITIONS&order.by=${orderKeyword}&pageNumber=${page}`
    )
  }
}

export async function getSearchProduct(
  keyword: string,
  orderby: string,
  pageNumber: number,
  min: number = 0,
  max: number = 1000000,
  brandList: string = '',
  sortDirection: string = 'DESC'
  // deliveryConditionType: boolean = false
) {
  // const freeCheck = deliveryConditionType && `FREE` // 축약된 조건
  const baseUrl = `/products/search`
  const queryParams = [
    `filter.soldout=true`,
    `filter.saleStatus=ALL_CONDITIONS`,
    `filter.discountedPrices=${min},${max}`,
    `order.soldoutPlaceEnd=true`,
    `order.by=${orderby}`,
    `order.direction=${sortDirection}`,
    `filter.keywords=${keyword}`,
    `brandNos=${brandList}`,
    `pageSize=12`,
    `pageNumber=${pageNumber}`,
  ]

  // if (freeCheck) {
  //   queryParams.push(`filter.deliveryConditionType=${freeCheck}`)
  // }

  const queryString = queryParams.join('&')

  if (accessToken) {
    return await userClient.get(`${baseUrl}?${queryString}`)
  } else {
    return await client.get(`${baseUrl}?${queryString}`)
  }
}

/** 전체 카테고리 조회하기 */
export async function getCategories(): Promise<{ data: CategoriesResponse }> {
  return await client.get(`/categories`)
}

/** 전체 카테고리 키워드로 조회 조회하기 */
export async function getCategoriesKeyword(keyword: string) {
  return await client.get(`/categories?keyword=${keyword}`)
}

/** 카테고리 조회하기 */
export async function getDetailCategories(categoryNo: number) {
  return await client.get(`/categories/${categoryNo}`)
}

/** 상품 옵션 검색 */
export async function getOptions(productNo: string) {
  if (accessToken) {
    return await userClient.get(`/products/${productNo}/options`)
  } else {
    return await client.get(`/products/${productNo}/options`)
  }
}

/** 옵션 이미지 정보 조회 */
export async function getOptionImages(productNo: string, optionNo: string) {
  return await client.get(`/products/${productNo}/options/${optionNo}/images`)
}

/** 비회원용 최근 본 상품 조회 */
export async function getGuestRecentProducts(mallProductNos: number[]) {
  return await client.get(`/guest/recent-products?mallProductNos=${mallProductNos}&soldout=true&hasOptionValues=false`)
}

/** 최근 본 상품 조회하기(회원) */
export async function getRecentProducts(page: number) {
  return await userClient.get(`/profile/recent-products?soldout=true&hasMaxCouponAmt=true&hasOptionValues=false`)
}

/** 최근 본 상품 등록하기(회원) */
export async function postRecentProducts(productNo: number) {
  return await userClient.post(`/profile/recent-products`, {
    productNo: productNo,
  })
}

/** 최근 본 상품 삭제하기(회원) */
export async function deleteRecentProducts() {
  return await userClient.delete(`/profile/recent-products`)
}

/** 상품 좋아요 카운트 */
export async function getLikeCount() {
  return await userClient.get(`/profile/like-products/count`)
}

/** 상품 좋아요 조회하기 */
export async function getLikeProducts(page: number) {
  return await userClient.get(`/profile/like-products?pageNumber=${page}&pageSize=50`)
}

/** 상품 좋아요 등록하기(Y:좋아요,N:해제하기)(회원) */
export async function postLikeProducts(items: any) {
  return await userClient.post(
    `/profile/like-products`,

    {
      items: [items],
    },

    {
      headers: {
        Version: 1.1,
      },
    }
  )
}
/* 
  items[{like:'Y',productNo:productNo}]
*/

/** 물품 상세 */
export async function getProductDetail(productNo: string) {
  if (accessToken) {
    return await userClient.get(`/products/${productNo}`)
  } else {
    return await client.get(`/products/${productNo}`)
  }
}

/** 재입고 알림 */
export async function postRestock(optionNos: Array<number>, name: string, phone: string) {
  return await userClient.post(`/products/restock`, {
    optionNos: optionNos,
    privacyInfoAgreement: true,
    name: name,
    phone: phone,
  })
}

/** 상품평 목록 조회하기 */
export async function getProductReviews(productNo: any, page: number, orderKeyword: string) {
  return await userClient.get(
    `/products/${productNo}/product-reviews?order.by=${orderKeyword}&pageNumber=${page}&pageSize=3`
  )
}

/** 상품평 등록하기 */
export async function postProductReviews(
  productNo: string,
  optionNo: number,
  orderOptionNo: number,
  content: string,
  rate: number,
  urls: Array<string>
) {
  return await userClient.post(`/products/${productNo}/product-reviews`, {
    optionNo: optionNo,
    orderOptionNo: orderOptionNo,
    content: content,
    rate: rate,
    urls: urls,
    extraJson: 'string',
  })
}

/** 상품평 수정하기 */
export async function putProductReviews(
  productNo: string,
  reviewNo: string,
  content: string,
  rate: number,
  urls: Array<string>
) {
  return await userClient.put(`/products/${productNo}/product-reviews/${reviewNo}`, {
    content: content,
    rate: rate,
    urls: urls,
  })
}

/** 상품평 삭제하기 */
export async function deleteProductReviews(productNo: string, reviewNo: string) {
  return await userClient.delete(`/products/${productNo}/product-reviews/${reviewNo}`)
}

/** 상품평 추천하기 */
export async function postReviewRecommend(productNo: string, reviewNo: string) {
  return await userClient.post(`/products/${productNo}/product-reviews/${reviewNo}/recommend`)
}

/** 상품평 추천삭제하기 */
export async function deleteReviewRecommend(productNo: string, reviewNo: string) {
  return await userClient.delete(`/products/${productNo}/product-reviews/${reviewNo}/recommend`)
}

/** 상품평 신고하기 */
export async function postReviewReport(
  productNo: string,
  reviewNo: string,
  reportReasonCd: string,
  content: string | null
) {
  return await userClient.post(`/products/${productNo}/product-reviews/${reviewNo}/report`, {
    reviewNo: reviewNo,
    reportReasonCd: reportReasonCd,
    content: content,
  })
}

/** 인기검색어 조회 */
export async function getFavoriteKeywords() {
  return await client.get(`/products/favoriteKeywords`)
}

/** 내상품평 */
export async function getMyReview() {
  return await userClient(`/profile/product-reviews?hasTotalCount=true`)
}

/** 상품평 추천 */
export async function postRecommend(productNo: string | number, reviewNo: string | number) {
  return await userClient.post(`/products/${productNo}/product-reviews/${reviewNo}/recommend`)
}

/** 상품평 추천 취소 */
export async function deleteRecommend(productNo: string | number, reviewNo: string | number) {
  return await userClient.delete(`/products/${productNo}/product-reviews/${reviewNo}/recommend`)
}

/** 상품평 가져오기 */
export async function getReviewDetail(productNo: string | number, reviewNo: string | number) {
  return await userClient.get(`/products/${productNo}/product-reviews/${reviewNo}`)
}

/** 브랜드 가져오기 */
export async function getBrand() {
  return await client.get(`/display/brands`)
}

/** 브랜드 추가 정보 조회 */
export async function getExtraInfo(displayBrandNos: number) {
  return await client.get(`/display/brands/extraInfo?displayBrandNos=${displayBrandNos}`)
}
